// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToolbarItem__button___oQGkF {
    margin: 0.8rem;
}

.ToolbarItem__selected___uUBnP {
    background-color: var(--color-control-bg-clear-hover);
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/Toolbar/ToolbarItem/ToolbarItem.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,qDAAqD;AACzD","sourcesContent":[".button {\n    margin: 0.8rem;\n}\n\n.selected {\n    background-color: var(--color-control-bg-clear-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ToolbarItem__button___oQGkF`,
	"selected": `ToolbarItem__selected___uUBnP`
};
export default ___CSS_LOADER_EXPORT___;
